import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  tableTabAt,
} from "../interfaces";
import { SURQUAL_GRID_TYPE_PAGE } from "./SURQUAL_GRID_TYPE";

export const MAPPING_GRID_TYPE_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  isStaff: true,
  label: "GRID_TYPE",
  menuLabel: "GRID_TYPE",
  pageLabel: "GRID_TYPE_TITLE_MAPPING",
  name: "mapping_grid_type",
  path: "grid_types",
  description: "CONF_DESC_MAPPING_GRID_TYPE",
  model: {
    entityName: "datafeed",
    label: "GRID_TYPE",
    path: "/api/mapping/grid-types",
    bulkPath: "/api/mapping/grid-types/bulk-updates",
    name: "Grille Tarifaire",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 2,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "grid_type.code",
        order: 3,
        label: "GRID_TYPE",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/grid-types/?is_unmapped=true",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/grid-types/export" },
    import: { path: "/api/mapping/grid-types/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        key: "datafeed",
        label: "DATA_FEED_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "connector",
        label: "CONNECTOR_CODE",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/grid-types/",
        apiParams: {
          page_size: 100,
          ordering: "code",
        },
        key: "grid_type",
        label: "GRID_TYPE",
        labelKey: "code",
        subCreationForm: tableTabAt(SURQUAL_GRID_TYPE_PAGE.tabs, 0),
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        readonly: true,
      },
      {
        key: "grid_type",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "grid_type",
        flex: "100%",
      },
    ],
  },
};
